export default __webpack_public_path__ + "d6cc37b1506c3cc3a95d67766ad12fb9.svg";